/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Spaces_Wizard_Step2_Connect_DescriptionInputs */



/**
* | output |
* | --- |
* | "Click the button below to connect your {provider} account" |
*
* @param {Spaces_Wizard_Step2_Connect_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_connect_description = /** @type {((inputs: Spaces_Wizard_Step2_Connect_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Connect_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Klicke auf die Schaltfläche unten, um dein ${i?.provider}-Konto zu verbinden`)
	return /** @type {LocalizedString} */ (`Click the button below to connect your ${i?.provider} account`)
});